import { FileText, LucideIcon, Mail, Search, Target } from "lucide-react";

import ApplicationsNavigationItem from "@/app/(discover)/components/sidebar/applications-navigation-item";
import InvitesNavigationItem from "@/app/(discover)/components/sidebar/invites-navigation-item";
import {
  NavigationItem as NavigationItemComponent,
  NavigationItemProps,
} from "@/app/(discover)/components/sidebar/navigation-item";
import { connectNavTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import routes, { DEFAULT_INVITE_TAB } from "@/lib/routes";

export interface NavigationItem {
  title: string;
  url: string;
  icon: LucideIcon;
  testId: string;
  Component: React.ComponentType<NavigationItemProps>;
}

export function getNavigationItems(): NavigationItem[] {
  return [
    {
      title: "Invites",
      url: routes.getCandidateInvites(DEFAULT_INVITE_TAB),
      Component: InvitesNavigationItem,
      icon: Mail,
      testId: connectNavTestIds.INVITES,
    },
    {
      title: "Jobs",
      url: routes.getJobs(),
      Component: NavigationItemComponent,
      icon: Search,
      testId: connectNavTestIds.JOBS,
    },
    {
      title: "Quiz",
      url: routes.getProfileQuiz(),
      Component: NavigationItemComponent,
      icon: Target,
      testId: connectNavTestIds.QUIZ,
    },
    {
      title: "Applications",
      url: routes.getCandidateApplications(),
      Component: ApplicationsNavigationItem,
      icon: FileText,
      testId: connectNavTestIds.APPLICATIONS,
    },
  ];
}
